import React, { Component } from "react";
import { withRouter } from "react-router";

import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import moment from "moment";

import debounce from "lodash.debounce";

import axios from "../../../axios-instance";

import Container from "../../../components/UI/Container/Container";
import Icon from "../../../components/UI/Icon/Icon";
import { Stepper } from "../../../components/Stepper/Stepper";
import NewLoader from "../../../components/NewLoader/NewLoader";

import { FillFields, ChoosePaymentMethod, SelectTickets } from "./Steps";
import TermsAndConditionsModal from "../TermsAndConditionsModal/TermsAndConditionsModal";
import { bankLogos, fee, paymentMethodOptions } from "../constants";
import { currencies } from "../../../constants/currencies";
import { createMerchantSin, getTotal } from "../helpers";
import { filterUnavailableTicketTemplates } from "../../../helpers/filterUnavailableTicketTemplates";
import { showInfoModal, showErrorModal } from "../../../modals";

import PleaseWait from "../../../images/please-wait-season-pass-modal.svg";
import ThanksForYourPurchase from "../../../images/thanks-for-your-purchase.svg";
import PartizanOpenSellingLogo from "../../../images/partizan-open-selling-logo.svg";

import "../SeasonPass.sass";
import "./PartizanOpenSelling.sass";

const MySwal = withReactContent(swal);

export const mapSeatIo = ({
  category: { label, key },
  labels: { section, parent, own },
  pricing: { price },
  eventData,
}) => {
  const [area, side] = section.split("-");
  const ticketTemplate = eventData.ticketTemplates.find(
    ({ categoryKey }) => +categoryKey === +key
  );
  const ticketTemplateId = ticketTemplate && ticketTemplate.ticketTemplateId;

  return {
    ticketTemplateId,
    ticketName: label,
    area: area,
    row: parent,
    seat: own,
    side: side,
    amount: price,
  };
};

export const mapSeat = (result, item) => {
  const { ticketTemplateId, count } = item;

  for (let i = 0; i < count; i++) {
    result.push({ ticketTemplateId: ticketTemplateId });
  }

  return result;
};

class PartizanOpenSelling extends Component {
  state = {
    fields: {
      fullName: "",
      physicalAddress: "",
      city: "",
      postalCode: "",
      phoneNumber: "",
      buyerEmail: "",
      birthday: null,
      gender: "",
      paymentMethod: paymentMethodOptions[0].value,
      companyName: "",
      companyVatNumber: "",
    },
    checkboxeFields: {
      termsAndConditionsChecked: false,
    },
    tickets: [],
    transactionData: {
      orderId: "",
      paymentAmount: "",
      currencyCode: "RSD",
      resURL: "",
      //TODO: should check
      sessionValidity: "2023-08-28T14:26:53.000Z",
      redirectURL: "",
      iFDirective: process.env.REACT_APP_ALLOWED_URL,
      signedKeys:
        "orderId,paymentAmount,currencyCode,sessionValidity,resURL,redirectURL,iFDirective",
    },
    eventData: null,
    isOffers: false,
    step: 1,
    themeColor: "#F95700",
    hasSeats: undefined,
    feeRate: fee,
    loading: true,
    submittBlocked: false,
    reapetedBuyerEmail: "",
  };

  formRef = React.createRef();

  handleaChangeStep = (nextStep) => {
    this.setState({ step: nextStep });
  };

  setOrderDataToState = (data) => {
    const fields = {
      ...this.state.fields,
      fullName: data.fullName,
      physicalAddress: data.physicalAddress,
      city: data.city,
      postalCode: data.postalCode,
      phoneNumber: data.phoneNumber,
      buyerEmail: data.buyerEmail,
      birthday: data.birthday ? data.birthday : null,
      gender: data.gender,
      companyName: data.companyName,
      companyVatNumber: data.companyVatNumber,
    };

    this.setState({
      fields,
    });
  };

  showSalesUnavailableModal = () => {
    MySwal.fire({
      title: "Sales not available",
      allowEscapeKey: false,
      customClass: "seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });
  };

  showPleaseWaitModal = () => {
    MySwal.fire({
      imageUrl: PleaseWait,
      title: "Please wait",
      text: "You will be redirected to the payment page",
      allowEscapeKey: false,
      customClass: "seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });
  };

  getOrderData = async () => {
    try {
      const { data } = await axios.get(
        `Transaction/${this.props.match.params.id}`
      );
      if (data) {
        this.handleOrderStatuses(data);
        this.setOrderDataToState(data);
      }
    } catch (e) {
      showErrorModal({
        text: `It seems to have failed to complete the payment, please try again`,
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      });
      console.log(e);
    }
  };

  setPrice = () => {
    const { tickets, hasSeats } = this.state;
    let price = 0;
    if (!hasSeats) {
      price = tickets.reduce((accumulator, ticket) => {
        return accumulator + ticket.price * ticket.count;
      }, 0);
    } else {
      price = tickets.reduce((accumulator, ticket) => {
        return accumulator + +ticket.pricing.price;
      }, 0);
    }
    this.setTransactionData({
      paymentAmount: price,
    });
  };

  handleOrderStatuses = (data) => {
    switch (data.paymentStatus) {
      //New
      case 0:
        break;
      //Success
      case 1:
        showInfoModal({
          image: ThanksForYourPurchase,
          title: "Thanks for Your Purchase!",
          text: `We will send all the details to your inbox (${data.buyerEmail}) and look forward to meeting you`,
          additionalText: `(Payment Status: ${
            data.additionalPaymentStatus
          }, Payment Date: ${moment(data.paymentDate).format(
            "DD MMMM YYYY HH:mm"
          )}, Transaction Id: ${data.transactionId})`,
          customClass:
            "seasonpass__modal_info seasonpass__modal partizan-info-modal",
        });
        this.setState({ submittBlocked: true });
        break;
      //Failed
      case 2:
        showErrorModal({
          text: `It seems to have failed to complete the payment, please try again`,
          customClass:
            "seasonpass__modal_info seasonpass__modal partizan-info-modal",
          additionalText: `(Payment Status: ${
            data.additionalPaymentStatus
          }, Payment Date: ${moment(data.paymentDate).format(
            "DD MMMM YYYY HH:mm"
          )}, Transaction Id: ${data.transactionId})`,
        });
        break;
      //Cancelled
      case 3:
        break;
      default:
        break;
    }
  };

  createPathnameWithOrderId = (id) => {
    const pathname = String(this.props.location.pathname);
    const splitedPathname = pathname.split("/");
    const isIncludeId = splitedPathname.length >= 4;
    if (isIncludeId) {
      return `/${splitedPathname[1]}/${splitedPathname[2]}/${id}`;
    }
    return pathname + "/" + id;
  };

  createRedirectURL = (id) => {
    const { isOffers } = this.state;

    if (isOffers) {
      return window.location.href + "?";
    }

    const origin = window.location.origin;
    const pathname = this.createPathnameWithOrderId(id);

    return `${origin}${pathname}?`;
  };

  setTransactionData = (data) => {
    const paymentAmount = data.paymentAmount;

    const orderId = data.orderId || this.state.transactionData.orderId || "";

    const transactionData = {
      ...this.state.transactionData,
      ...data,
      orderId,
      redirectURL: this.createRedirectURL(orderId),
      resURL: `${process.env.API_URL}/Payment/Webhook/Kopa`,
    };

    if (paymentAmount) {
      transactionData.paymentAmount = getTotal(
        paymentAmount,
        this.state.feeRate
      );
    }

    transactionData.merchantSig = createMerchantSin(
      transactionData,
      transactionData.signedKeys
    );

    this.setState({
      transactionData,
    });
  };

  createOrder = async () => {
    const {
      fields: { paymentMethod, ...otherFields },
      transactionData,
      tickets,
      eventData,
      hasSeats,
      isOffers,
    } = this.state;

    let seats = tickets;

    if (!isOffers) {
      seats = hasSeats
        ? tickets.map((ticket) => mapSeatIo({ ...ticket, eventData }))
        : tickets.reduce(mapSeat, []);
    }

    const body = {
      transaction: {
        ...otherFields,
        id: isOffers ? this.props.match.params.transactionId : undefined,
        currency: transactionData.currencyCode,
        amount: transactionData.paymentAmount,
        seats,
        seatsIoEventId: eventData.seatsIoEventId,
      },
    };

    const { data: id } = await axios.post("Transaction/createForSell", body);

    this.setTransactionData({
      orderId: id,
    });

    if (!isOffers) {
      const pathname = this.createPathnameWithOrderId(id);

      this.props.history.push({
        pathname,
      });
    }
  };

  handleSubmit = async () => {
    try {
      this.showPleaseWaitModal();
      await this.createOrder();
      this.formRef.current.submit();
    } catch (e) {
      console.log(e);
      showErrorModal({
        text: `It seems to have failed to complete the payment, please try again`,
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      });
    }
  };

  handleChange = (name, value) => {
    if (name) {
      this.setState({ fields: { ...this.state.fields, [name]: value } });
    }
  };

  handleRepaetEmailChange = debounce((value) => {
    this.setState({ reapetedBuyerEmail: value });
  }, 700);

  showTermsAndConditionsModal = (ev) => {
    ev.preventDefault();
    MySwal.fire({
      html: <TermsAndConditionsModal />,
      width: "64em",
      customClass: "seasonpass__modal partizan-info-modal",
    });
  };

  handleChangeCheckbox = (name) => {
    if (name) {
      this.setState({
        checkboxeFields: {
          ...this.state.checkboxeFields,
          [name]: !this.state.checkboxeFields[name],
        },
      });
    }
  };

  checkActionButtonDisabled = () => {
    const {
      step,
      fields: {
        companyName,
        companyVatNumber,
        paymentMethod,
        birthday,
        ...otherFields
      },
      checkboxeFields,
      submittBlocked,
      tickets,
      loading,
      isOffers,
      reapetedBuyerEmail,
    } = this.state;

    if (submittBlocked || loading) return true;

    if (isOffers) return false;

    switch (step) {
      case 1:
        return !tickets.length;
      case 3:
        return !paymentMethod || reapetedBuyerEmail !== otherFields.buyerEmail;
      case 2:
        return (
          !checkboxeFields.termsAndConditionsChecked ||
          !Object.keys(otherFields).every((key) => !!otherFields[key]) ||
          !moment(birthday).isValid()
        );
      default:
        return false;
    }
  };

  onObjectSelected = (obj) => {
    const { hasSeats } = this.state;
    if (!hasSeats) {
      let findedTicket = this.state.tickets.find(
        ({ ticketTemplateId }) => ticketTemplateId === obj.ticketTemplateId
      );

      if (findedTicket) {
        this.setState(
          {
            tickets: this.state.tickets.map((ticket) =>
              ticket.ticketTemplateId === obj.ticketTemplateId ? obj : ticket
            ),
          },
          () => this.setPrice()
        );
        return;
      }
    }
    if (hasSeats && !obj.pricing) {
      return;
    }
    const tickets = [...this.state.tickets, obj];

    this.setState({ tickets }, () => this.setPrice());
  };

  onObjectDeselected = (obj) => {
    const { hasSeats } = this.state;
    if (!hasSeats) {
      this.setState(
        {
          tickets: this.state.tickets.filter(
            (item) => item.ticketTemplateId !== obj.ticketTemplateId
          ),
        },
        () => this.setPrice()
      );
      return;
    }

    this.setState(
      {
        tickets: this.state.tickets.filter((item) => item.id !== obj.id),
      },
      () => this.setPrice()
    );
  };

  setEventData = (data = {}, shouldfilterUnavailable = true) => {
    document.documentElement.style.setProperty(
      "--partizan-theme",
      this.state.themeColor
    );

    if (!data.isSalesAvailable) {
      this.setState({ submittBlocked: true });
      this.showSalesUnavailableModal();
    }

    if (shouldfilterUnavailable) {
      data.ticketTemplates = filterUnavailableTicketTemplates(
        data.ticketTemplates
      );
    }

    this.setState({
      transactionData: {
        ...this.state.transactionData,
        currencyCode: currencies.find(({ value }) => value === data.currencyId)
          .label,
      },
      hasSeats: data.ticketTemplates.length
        ? data.ticketTemplates[0].hasSeats
        : undefined,
      feeRate: data.feeRate || fee,
      eventData: data,
    });
  };

  getEventData = async (transactionId) => {
    if (transactionId) {
      const { data } = await axios.get(
        `/Transaction/Event/ByTransactionId/${transactionId}`
      );
      this.setEventData(data, false);
      return;
    }

    const eventSlug = this.props.match.params.slug;
    const { data } = await axios.get(`/Transaction/Event/BySlug/${eventSlug}`);
    this.setEventData(data);
  };

  getTransactionData = async () => {
    const transactionId = this.props.match.params.transactionId;

    let tickets = [];

    await this.getEventData(transactionId);

    const { data } = await axios.get(
      `Transaction/TransactionCreationModel/${transactionId}`
    );

    const serializedTransactionCreationModel = JSON.parse(
      data.serializedTransactionCreationModel
    );

    const transactionModel = {};

    for (const key in serializedTransactionCreationModel) {
      if (serializedTransactionCreationModel.hasOwnProperty(key)) {
        const newKey = key.charAt(0).toLowerCase() + key.slice(1);
        transactionModel[newKey] = serializedTransactionCreationModel[key];
      }
    }

    this.handleOrderStatuses(transactionModel);
    this.setOrderDataToState(transactionModel);

    tickets = serializedTransactionCreationModel.Seats.map((seat) => ({
      ticketTemplateId: seat.TicketTemplateId,
      count: 1,
      name: `${seat.TicketName} ${seat.Area}, Row ${seat.Row} Seat ${seat.Seat} ${seat.Side}`,
      ticketName: seat.TicketName,
      amount: seat.Amount,
      price: +seat.Amount,
      area: seat.Area,
      row: seat.Row,
      seat: seat.Seat,
      side: seat.Side,
    }));

    this.setState(
      {
        tickets,
        hasSeats: false,
      },
      () => {
        this.setPrice();
      }
    );
  };

  callAPIs = async () => {
    try {
      this.setState({ loading: true });
      const { id, slug, transactionId } = this.props.match.params;

      switch (true) {
        case !!slug:
          await this.getEventData();
          break;
        case !!transactionId:
          this.setState({ isOffers: true });
          await this.getTransactionData();
          break;
        default:
          throw Error();
      }

      if (id) {
        await this.getOrderData();
      }

      this.setState({ loading: false });
    } catch (e) {
      this.setState({ loading: false });
      showErrorModal({
        text: `It seems to have failed to complete the payment, please try again`,
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      });
      console.log(e);
    }
  };

  componentDidMount() {
    this.callAPIs();
  }

  render() {
    const {
      step,
      fields,
      checkboxeFields,
      tickets,
      transactionData,
      eventData,
      loading,
      hasSeats,
      feeRate,
      isOffers,
      reapetedBuyerEmail,
    } = this.state;

    if (loading && !isOffers) {
      return <NewLoader isFullScreen />;
    }

    if (!eventData) {
      return null;
    }

    const time = moment(eventData.startDate).format("DD.MM.YYYY HH:mm");

    const pricing = eventData.ticketTemplates.map(({ categoryKey, price }) => ({
      category: categoryKey,
      price,
    }));

    const prefixLabel = eventData.prefixLabel || "";

    const location = eventData.place || "";

    const { companyVatNumber, companyName, ...otherFields } = fields;
    const requiredFields = Object.keys(otherFields);

    const offerSteps = [
      {
        title: "Buy tickets",
        component: (
          <SelectTickets
            feeRate={feeRate}
            isOffers
            tickets={tickets}
            ticketTemplates={eventData.ticketTemplates}
            pricing={pricing}
            hasSeats={hasSeats}
            workspaceKey={eventData.seatsIoWorkspaceId}
            event={eventData.seatsIoEventId}
            loading={loading}
            currency={transactionData.currencyCode}
            onObjectSelected={this.onObjectSelected}
            onObjectDeselected={this.onObjectDeselected}
            total={transactionData.paymentAmount}
          />
        ),
      },
    ];

    const steps = [
      {
        title: "Select Tickets",
        component: (
          <SelectTickets
            feeRate={feeRate}
            tickets={tickets}
            ticketTemplates={eventData.ticketTemplates}
            pricing={pricing}
            hasSeats={hasSeats}
            workspaceKey={eventData.seatsIoWorkspaceId}
            event={eventData.seatsIoEventId}
            currency={transactionData.currencyCode}
            onObjectSelected={this.onObjectSelected}
            onObjectDeselected={this.onObjectDeselected}
            total={transactionData.paymentAmount}
          />
        ),
      },
      {
        title: "Fill in the info",
        component: (
          <FillFields
            fields={fields}
            requiredFields={requiredFields}
            handleChange={this.handleChange}
            checkboxeFields={checkboxeFields}
            showTermsAndConditionsModal={this.showTermsAndConditionsModal}
            handleChangeCheckbox={this.handleChangeCheckbox}
          />
        ),
      },
      {
        title: "Buy tickets",
        component: (
          <ChoosePaymentMethod
            buyerEmail={fields.buyerEmail}
            reapetedBuyerEmail={reapetedBuyerEmail}
            handleRepaetEmailChange={this.handleRepaetEmailChange}
            feeRate={feeRate}
            hasSeats={hasSeats}
            currency={transactionData.currencyCode}
            email={fields.buyerEmail}
            tickets={tickets}
            total={transactionData.paymentAmount}
            paymentMethod={fields.paymentMethod}
            handleChange={this.handleChange}
          />
        ),
      },
    ];

    const headerComponent = (
      <div>
        <h2 className="partizan-open-selling__stepper-header-event-name">
          {prefixLabel}
        </h2>
        <h2 className="partizan-open-selling__stepper-header-title">
          {eventData.eventName}
        </h2>
        <h5 className="partizan-open-selling__stepper-header-subtitle">
          Supported by Fancee tickets
        </h5>
        <div className="partizan-open-selling__stepper-header-info">
          <div className="partizan-open-selling__stepper-header-info-location">
            <Icon name={"map-pin-solid"} />
            <p>{location}</p>
          </div>
          <p className="partizan-open-selling__stepper-header-info-time">
            {time}
          </p>
        </div>
      </div>
    );

    const offerActionComponent = (
      <div className="partizan-open-selling__stepper-action">
        <div
          style={{ justifyContent: "flex-end" }}
          className="partizan-open-selling__stepper-action-btns"
        >
          <button
            className="btn-primary"
            type="button"
            disabled={this.checkActionButtonDisabled()}
            onClick={this.handleSubmit}
          >
            Pay
          </button>
        </div>
        <div className="seasonpass__bank-logos">
          {bankLogos.map(({ alt, src }) => (
            <div key={alt}>
              <img src={src} alt={alt} />
            </div>
          ))}
        </div>
      </div>
    );

    const actionComponent = (
      <div className="partizan-open-selling__stepper-action">
        <div className="partizan-open-selling__stepper-action-btns">
          <button
            className="btn-secondary"
            type="button"
            disabled={step === 1}
            onClick={() => this.handleaChangeStep(step - 1)}
          >
            Previous
          </button>
          {steps.length === step && (
            <button
              className="btn-primary"
              type="button"
              disabled={this.checkActionButtonDisabled()}
              onClick={this.handleSubmit}
            >
              Pay
            </button>
          )}
          {steps.length !== step && (
            <button
              className="btn-primary"
              type="button"
              disabled={this.checkActionButtonDisabled()}
              onClick={() => this.handleaChangeStep(step + 1)}
            >
              Next
            </button>
          )}
        </div>
        <div className="seasonpass__bank-logos">
          {bankLogos.map(({ alt, src }) => (
            <div key={alt}>
              <img src={src} alt={alt} />
            </div>
          ))}
        </div>
      </div>
    );

    return (
      <Container className="seasonpass partizan-open-selling">
        <form
          ref={this.formRef}
          action={process.env.REACT_APP_PAYMENT_LINK}
          method="post"
          className="partizan-open-selling__wrapper"
        >
          {Object.keys(transactionData).map((key) => (
            <input
              name={key}
              key={key}
              type="hidden"
              value={transactionData[key]}
            />
          ))}
          <div className="partizan-open-selling__logo seasonpass__header-logo-wrapper">
            <img src={PartizanOpenSellingLogo} alt="Logo" />
            <h2>Fancee Tickets</h2>
          </div>
          <Stepper
            headerBgStyle={{
              backgroundImage: `url(${eventData.imageUrl})`,
            }}
            headerWrapperClass="partizan-open-selling__stepper-header"
            headerComponent={headerComponent}
            actionComponent={isOffers ? offerActionComponent : actionComponent}
            currentStep={step}
            steps={isOffers ? offerSteps : steps}
          />
        </form>
      </Container>
    );
  }
}

export default withRouter(PartizanOpenSelling);
